import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  websiteContentIcon,
  seoContentIcon,
  adCopyContentIcon,
  socialMediaContentIcon,
  personalBrandingContentIcon,
} from "../../../../assets/icons/serviceIcon/index";
import PodcastContentWork from "./PodcastContentWork";

const items = [
  {
    name: "Planning & Scripting",
    text: "Get complete episode scripts written from start to finish, shaped around your ideas and refined to match your tone and flow.",
  },
  {
    name: "Podcast Content Strategy",
    text: "Create content buckets, episode ideas, and collaboration angles to build a strong podcast strategy that aligns with your brand and audience.",
  },
  {
    name: "Repurposing Episodes into Written Content",
    text: "Turn your episodes into blogs, social posts, or quotes giving your voice a wider reach without recording more content.",
  },
];

const otherService = [
  {
    icon: seoContentIcon,
    name: "Seo Blog Writing",
    des: "Blog posts that teach, tell stories and rank on Google",
    path: "/seo-blog-writing",
  },
  {
    icon: adCopyContentIcon,
    name: "Ad Copy & Sales Funnels",
    des: 'Clear words that guide people from curiosity to clicking "yes"',
    path: "/ad-copy-and-sale-funnels",
  },
  {
    icon: socialMediaContentIcon,
    name: "Social Media Strategy",
    des: "Plan smart, scroll-worthy posts that actually speak to your audience",
    path: "/social-media-strategy",
  },
  {
    icon: personalBrandingContentIcon,
    name: "Personal Branding Content",
    des: "Bring your voice to life across everything your audience sees",
    path: "/personal-branding-content",
  },
  {
    icon: websiteContentIcon,
    name: "Website Content",
    des: "Make your website speak your value in the simplest way",
    path: "/website-content",
  },
];
const PodcastContent = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Editing"
        description="A good podcast starts with great writing. We help you plan episodes, write scripts and craft content that sounds clear, natural, and worth listening to."
        heading="Podcast Scripting &"
      />
      <NewCommonServiceForm title="Podcast Scripting & Editing" items={items} />
      <PodcastContentWork/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default PodcastContent;
